import styled from 'styled-components'
import { Tab } from '@headlessui/react'

export const Wrapper = styled.div`
  outline: none;

  &:focus,
  div[role='tabpanel'] {
    outline: none;
  }
`

export const TabButton = styled(Tab)<{ $numTabs: number }>`
  background: transparent;
  border: 0;
  outline: 0;
  font-weight: var(--font-bold);
  position: relative;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
  transition: 0.15s var(--cubicBezier);
  cursor: pointer;
  color: var(--brand-secondary);

  &:before {
    content: '';
    display: block;
    border-left: 7px solid var(--brand-primary);
    border-top: 5px solid transparent;
    border-bottom: 5px solid transparent;
    border-radius: 2px;
    transition: 0.25s var(--cubicBezier);
    left: -8px;
    position: absolute;
    opacity: 0;
  }

  &:after {
    content: '';
    display: block;
    position: absolute;
    bottom: -10px;
    left: 0;
    width: 100%;
    background: var(--brand-primary);
    height: 3px;
    transition: 0.15s var(--cubicBezier);
    opacity: 0;
  }

  &[aria-selected='true'] {
    color: var(--brand-primary);
    padding-left: 12px;

    &:before {
      opacity: 1;
      left: 0;
    }

    &:after {
      opacity: 1;
    }
  }
`

export const TabList = styled(Tab.List)`
  display: flex;
  justify-content: flex-start;
  align-items: stretch;
  gap: 25px;
`
